import { Control, useWatch } from 'react-hook-form';

import { DateFilterType } from '../../../AppointmentsFilterChips/DateChipFilter.types';
import { FilterFormBean } from '../../AppointmentsFilterPanel';

import { ButtonGroupField } from './ButtonGroupField';

export const useGetDateFilterTypeChoice = (control: Control<FilterFormBean>): DateFilterType | null => {
   const choice = useWatch<DateFilterType | null>({
      name: ButtonGroupField.fieldName,
      control: control,
   });

   return choice || null;
};
